module.exports = __webpack_public_path__ + "static/media/header-network-esc.cabb2115.svg";